import * as types from './constants';

// Get Shopify Variant Stock
export const getShopifyVariantStockRequest = data => (
  { type: types.GET_SHOPIFY_VARIANT_STOCK_REQUEST, payload: data }
);

export const getShopifyVariantStockDone = data => (
  { type: types.GET_SHOPIFY_VARIANT_STOCK_DONE, payload: data }
);

export const getShopifyVariantStockFailed = errors => (
  { type: types.GET_SHOPIFY_VARIANT_STOCK_FAILED, payload: errors }
);

export const getShopifyVariantStockReset = () => (
  { type: types.GET_SHOPIFY_VARIANT_STOCK_RESET }
);
